import { Dialog } from "@headlessui/react";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { ModalFoterBox, ModalHeaderBox } from "../../components/box/Box";
import { useForm } from "react-hook-form";
import { UserData } from "../../model/Users";

export type ChangeAccountSuspensionModalProps = {
  onSubmit: (data: UserData) => Promise<void>;
};

export const ChangeAccountSuspensionModal = ({
  open,
  toggle,
  closeOnClickOutside,
  onSubmit
}: ModalProp & ChangeAccountSuspensionModalProps) => {
  const { handleSubmit } = useForm<UserData>();

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <form
            className=""
            onSubmit={handleSubmit(onSubmit)}
            method="POST"
            noValidate
        >
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <ModalHeaderBox
                title={"利用停止に変更されています"}
              />
              <div className="text-left pl-5 mt-3">
                <div>
                    {`一度アプリ利用を「利用停止」に変更すると元に戻せません。`}
                </div>
                <div>
                    {'編集しますか？'}
                </div>
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mr-2 w-[132px]"
              outline
              color={"indigo"}
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              submit
              children={"登録"}
              className="mr-2 w-[132px]"
            />
          </ModalFoterBox>
        </form>
      </Dialog.Panel>
    </Modal>
  );
};
